import { render, staticRenderFns } from "./TabEnergy.vue?vue&type=template&id=56a00d77&scoped=true&"
import script from "./TabEnergy.vue?vue&type=script&lang=js&"
export * from "./TabEnergy.vue?vue&type=script&lang=js&"
import style0 from "./TabEnergy.vue?vue&type=style&index=0&id=56a00d77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a00d77",
  null
  
)

export default component.exports